import { Injectable } from '@angular/core';
import { DialogService } from '../controls/message-dialog/message-dialog.service';

@Injectable({
    providedIn: 'root'
})
export class ErrorService {

    constructor(private dialogService: DialogService) {}

    handleError(error: any): void {
        const type = 'Error';
        const title = 'Error';

        let message = this.getDefaultErrorMessage(error);

        this.dialogService.show(type, message, title);
    }

    getDefaultErrorMessage(error: any): string {
        const apiMessage = this.extractApiMessage(error);
        if (apiMessage) {
            return apiMessage;
        }

        if (error.status === 400) {
            return 'Request invalid.';
        }
        else if (error.status === 404) {
            return 'Requested resource not found.';
        }

        return 'An unexpected error occurred.';
    }

    private extractApiMessage(error: any): string | null {
        if (!error) {
            return null;
        }

        if (typeof error.message === 'string' && error.message.trim().length > 0 && error.message !== 'Http failure response for (unknown url): 0 Unknown Error') {
            if (!['Bad Request', 'Not Found', 'Internal Server Error', 'An unexpected server error occurred.', 'Server Error'].includes(error.message)) {
                return error.message;
            }
        }

        if (error.response && typeof error.response === 'string') {
            try {
                const parsed = JSON.parse(error.response);
                if (parsed?.message && typeof parsed.message === 'string') {
                    return parsed.message;
                }
            }
            catch {
                // Ignore non-JSON response bodies.
            }
        }

        if (error.error?.message && typeof error.error.message === 'string') {
            return error.error.message;
        }

        return null;
    }
}